/** 種別・コード値共通定数クラス */

// *****************************************************************
// 共通
// *****************************************************************

/** HTTPステータス */
export const HTTP_STATUS = {
  OK: 200,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500
}

/** API結果コード */
export const RESULT_CODE = {
  OK: '00',
  BAD_REQUEST: '11',
  UNAUTHORIZED: '12',
  FORBIDDEN: '13',
  NOT_FOUND: '14',
  INVALID_SPACE_EDIT: '21',
  SYSTEM_ERROR: '99'
}

/** ユーザー種別 */
export const USER_TYPE = {
  DOMANS_ADMIN: {code: 'DOMANS_ADMIN', label: 'domans'},
  ADMIN: {code: 'ADMIN', label: '管理担当'},
  DEVELOPER: {code: 'DEVELOPER', label: '設計担当'},
  PLANNER: {code: 'PLANNER', label: 'プランナー'},
  MANUFACTURER: {code: 'MANUFACTURER', label: '生産担当'},
  VISITOR: {code: 'VISITOR', label: '閲覧者'},
  MAKER: {code: 'MAKER', label: 'メーカー'},
  STRUCT: {code: 'STRUCT', label: '施工業者'},
  FACTORY: {code: 'FACTORY', label: '工場'},
  DELIVERY: {code: 'DELIVERY', label: '配送業者'},
  SYSTEM_ADMIN: {code: 'SYSTEM_ADMIN', label: 'システム管理者'},
  SYSTEM_OPERATOR: {code: 'SYSTEM_OPERATOR', label: 'システム運用者'},
  SYSTEM_USER: {code: 'SYSTEM_USER', label: 'システム参照者'}
}

/** 契約種別 */
export const LICENSE_TYPE = {
  BASIC: 1,
  PRO: 2,
  CUSTUMIZED: 3,
  TRIAL: 4
}

// *****************************************************************
// 空間
// *****************************************************************

/** 空間種別 */
export const SPACE_TYPE = {
  ELEMENT: 'TYPE_SP_ELEMENT', // 素材空間
  GROUP: 'TYPE_SP_GROUP', // グループ空間
  PLAN: 'TYPE_SP_PLAN' // プランニング空間
}

/** 空間レベル */
export const SPACE_LEVEL = {
  ELEMENT: 'LV_SP_ELEMENT', // 素材
  PARTS: 'LV_SP_PARTS', // パーツ
  UNIT: 'LV_SP_UNIT', // ユニット
  COMBINE: 'LV_SP_COMBINE', // コンバイン
  SETPLAN: 'LV_SP_SETPLAN', // プランセット
  ROOM: 'LV_SP_ROOM', // ルーム
  PLAN: 'LV_SP_PLAN' // プラン
}

/** オブジェクト空間種別 */
export const OBJECT_TYPE = {
  ELEMENT: {code: 'TYPE_OBJ_ELEMENT', label: '素材'},
  FITTING: {code: 'TYPE_OBJ_FITTING', label: '金具'},
  FITTINGSET: {code: 'TYPE_OBJ_FITTINGSET', label: '金具セット'},
  PARTS: {code: 'TYPE_OBJ_PARTS', label: 'パーツ'},
  UNIT: {code: 'TYPE_OBJ_UNIT', label: 'ユニット'},
  COMBINE: {code: 'TYPE_OBJ_COMBINE', label: 'コンバイン'},
  COMBINESET: {code: 'TYPE_OBJ_COMBINESET', label: 'コンバインセット'},
  SETPLAN: {code: 'TYPE_OBJ_SETPLAN', label: 'セットプラン'},
  SETPLAN_FIX: {code: 'TYPE_OBJ_SETPLAN_FIX', label: 'セットプラン(固定)'},
  ROOM: {code: 'TYPE_OBJ_ROOM', label: 'ルーム'},
  PLAN: {code: 'TYPE_OBJ_PLAN', label: 'プラン'},
  CELL: {code: 'TYPE_OBJ_CELL', label: 'セル'},
  UNITCOMPONENT: {code: 'TYPE_OBJ_UNITCOMPONENT', label: 'ユニットコンポーネント'},
  ACCESSORY: {code: 'TYPE_OBJ_ACCESSORY', label: 'アクセサリー'},
  OTANI: {code: 'TYPE_OBJ_OTANI', label: 'OTANI_CSV'},
  LIXIL: {code: 'TYPE_OBJ_LIXIL', label: 'LIXIL_CSV'},
  DELETE: {code: 'TYPE_OBJ_DELETE', label: '一括削除'},
  SUGATSUNE: {code: 'TYPE_OBJ_SUGATSUNE', label: 'スガツネ'}
}

/** オブジェクト詳細種別 */
export const OBJECT_DTL_TYPE = {
  PARTS_DAMMY: {code: 1000, label: 'DAMMY'},
  PART_TOP_BOARD: {code: 1010, label: '天板'},
  PART_BOTTOM_BOARD: {code: 1020, label: '地板'},
  PART_SHELF_BOARD: {code: 1090, label: '棚板'},
  PART_BASE_DRAWER: {code: 2100, label: '底板(引出)'},
  PART_TOP_DRAWER: {code: 2140, label: '前板(引出)'},
  PART_DOOR: {code: 2000, label: '扉'},
  PART_COUNTER: {code: 3000, label: 'カウンター'},
  UNIT_CONST_: {code: 10000, label: 'DAMMY-固定棚'},
  UNIT_INNER_SEPARATOR_DAMMY: {code: 10001, label: 'DAMMY-中仕切り'},
  UNIT_SKELTON_DAMMY: {code: 10002, label: 'DAMMY-スケルトン'},
  UNIT_SKELTON_OTHER: {code: 10120, label: 'スケルトン-他'},
  UNIT_FIX_SHELF: {code: 10200, label: '固定棚'},
  UNIT_INNER_SEPARATOR: {code: 10210, label: '中仕切り'},
  UNIT_DRAWER: {code: 12000, label: '引出し'},
  UNIT_MOBILE_SHELF: {code: 13000, label: '可動棚'},
  UNIT_MOBILE_SEPARATOR: {code: 13100, label: '可動縦仕切り'},
  UNIT_MOBILE_FRONT_BACK_SEPARATOR: {code: 13150, label: '可動前後仕切り'},
  UNIT_MOBILE_WARDROBE_RAIL: {code: 13200, label: 'ワードローブレール'},
  UNITCOMP_FRONT_DRAWER: {code: 15000, label: '引出し-前板'},
  UNIT_COUNTER: {code: 20000, label: 'カウンター'},
  UNIT_ENDPANEL: {code: 30000, label: 'エンドパネル'},
  UNIT_BACKPANEL: {code: 32000, label: 'エンドパネル'}
}

/** ユニットグループタイプ種別 */
export const UNIT_GROUP_TYPE = {
  SKELTON: {code: 'TYPE_UNITGRP_SKELTON', label: 'キャビネット', num: 1},
  INFILL: {code: 'TYPE_UNITGRP_INFILL', label: 'インフィル', num: 2},
  SURFACE: {code: 'TYPE_UNITGRP_SURFACE', label: 'サーフェス', num: 3},
  BODY: {code: 'TYPE_UNITGRP_BODY', label: '躯体', num: 4},
  ACCESSORY: {code: 'TYPE_UNITGRP_ACCESSORY', label: 'アクセサリー', num: 5}
}

/** オブジェクトグループ種別 */
export const OBJECT_GROUP_TYPE = {
  CABINET: {code: 'TYPE_OBJGRP_UT_CABINET', label: 'キャビネット', num: 10},
  DOOR: {code: 'TYPE_OBJGRP_UT_DOOR', label: 'ドア', num: 15},
  DRAWER: {code: 'TYPE_OBJGRP_UT_DRAWER', label: '引き出し', num: 20},
  SHELF_H: {code: 'TYPE_OBJGRP_UT_SHELF_H', label: '棚', num: 30},
  COUNTER: {code: 'TYPE_OBJGRP_UT_COUNTER', label: 'カウンター', num: 40},
  PANEL: {code: 'TYPE_OBJGRP_UT_PANEL', label: 'パネル類', num: 50},
  SHELF_V: {code: 'TYPE_OBJGRP_UT_SHELF_V', label: '仕切り', num: 60},
  DOOR_IN: {code: 'TYPE_OBJGRP_UT_DOOR_IN', label: 'インセットドア', num: 70},
  DOOR_OUT: {code: 'TYPE_OBJGRP_UT_DOOR_OUT', label: 'アウトセットドア', num: 75},
  INFILL: {code: 'TYPE_OBJGRP_UT_INFILL', label: 'インフィル', num: 80},
  BASEBOARD: {code: 'TYPE_OBJGRP_UT_BASEBOARD', label: '巾木', num: 90},
  FILLER: {code: 'TYPE_OBJGRP_UT_FILLER', label: 'フィラー類', num: 110},
  OPTION: {code: 'TYPE_OBJGRP_UT_OPTION', label: 'オプション', num: 120},
  ACCESSORY: {code: 'TYPE_OBJGRP_UT_ACCESSORY', label: 'アクセサリー', num: 130},
  SETPLAN: {code: 'TYPE_OBJGRP_SETPLAN', label: 'セットプラン', num: 140},
  ETC: {code: 'TYPE_OBJGRP_UT_ETC', label: 'ユニットその他', num: 150},
  CB: {code: 'TYPE_OBJGRP_CB', label: 'コンバイン', num: 160},
  DUMMY: {code: 'TYPE_OBJGRP_DUMMY', label: 'ダミー', num: 890}
}

/** プランニング種別 */
export const PLANNING_TYPE = {
  ELEMENT: 'TYPE_PLN_ELEMENT_DEFAULT', // 素材標準
  PARTS: 'TYPE_PLN_PARTS_DEFAULT', // パーツ標準
  UNIT: 'TYPE_PLN_UNIT_DEFAULT', // ユニット標準
  UNIT_SKELTON: 'TYPE_PLN_UNIT_SKELTON', // スケルトン
  UNIT_SHELF: 'TYPE_PLN_UNIT_SHELF', // 棚
  UNIT_DOOR: 'TYPE_PLN_UNIT_DOOR', // 扉
  UNIT_DRAWER: 'TYPE_PLN_UNIT_DRAWER', // 引出し
  UNIT_INFILL: 'TYPE_PLN_UNIT_INFILL', // インフィル
  UNIT_SURFACE: 'TYPE_PLN_UNIT_SURFACE', // 表面配置
  UNIT_FACE_OPTION: 'TYPE_PLN_UNIT_FACE_OPTION', // 表面オプション
  UNIT_COMP_DOOR: 'TYPE_PLN_UCOMP_DOOR', // ユニットコンポーネント：前板
  UNIT_COMP_INFILL: 'TYPE_PLN_UCOMP_INFILL', // ユニットコンポーネント：インフィル
  COMBINE: 'TYPE_PLN_COMB_DEFAULT', // コンバイン
  ACCESSORY: 'TYPE_PLN_ACCESSORY', // 装飾アイテム
  FRAME: 'TYPE_PLN_FRAME', // 壁
  JOINERY: 'TYPE_PLN_JOINERY', // 建具
  SETPLAN: 'TYPE_PLN_SETPLAN', // セットプラン
  UNDEFINED: 'UNDEFINED' // 未定義
}

/** サービス種別 */
export const SERVICE_TYPE = {
  DAROS: {label: 'daros', code: 0},
  MMSTYLE: {label: 'mm/style', code: 1},
  KAGULL: {label: 'kagle', code: 3},
  YASUMOKU: {label: 'yasumoku', code: 100}
}

/** 属性キー種別 */
export const ATTRIBUTE_KEY = {
  // 空間
  SP_CELL_LINKED_DOOR: 'SP_CELL_LINKED_DOOR',
  SP_CELL_LINKED_PANEL: 'SP_CELL_LINKED_PANEL',
  SP_CELL_RATIO: 'SP_CELL_RATIO',
  SP_MODULE: 'SP_MODULE',
  // ユニット
  UT_FLAG_ALIGN_DIR: 'UT_FLAG_ALIGN_DIR',
  UT_FLAG_DOOR_WRAP: 'UT_FLAG_DOOR_WRAP',
  UT_COUNTER_LEDGE: 'UT_COUNTER_LEDGE',
  UT_SURFACE_LEDGE: 'UT_SURFACE_LEDGE',
  UT_FACEOP_INFO: 'UT_FACEOP_INFO',
  // パーツ
  PT_DOOR_OPEN_TYPE: 'PT_DOOR_OPEN_TYPE',
  PT_FLAG_DIR: 'PT_FLAG_DIR',
  // 素材
  EL_SET_COLOR_DATA: 'EL_SET_COLOR_DATA'
}

/** 配列方向 */
export const BOARD_DIR_TYPE = {
  /** 水平 */
  TYPE_BOARD_DIR_1: 1,
  /** 垂直（サイド） */
  TYPE_BOARD_DIR_2: 2,
  /** 垂直（扉） */
  TYPE_BOARD_DIR_3: 3
}

/** 木目方向情報(オブジェクトデータ) */
export const GRAIN_DIRECTION_TYPE = {
  /** 正方向 */
  GRAIN_POSITIVE_DIRECTION: 0,
  /** 反対方向 */
  GRAIN_REVERSE_DIRECTION: 1,
  /** 木目なし */
  GRAIN_NONE: 9
}

/** 木目方向 */
export const GRAIN_SETTING_TYPE = {
  /** 木目なし */
  TYPE_GRAIN_NONE: 0,
  /** 縦目 */
  TYPE_GRAIN_VERTICAL: 1,
  /** 横目 */
  TYPE_GRAIN_HORIZON: 2
}

/** 素材の面タイプ */
export const ELEMENT_FACE_TYPE = {
  /** 右面 */
  RIGHT: {label: 'RIGTHT', code: 1},
  /** 左面 */
  LEFT: {label: 'LEFT', code: 2},
  /** 上面 */
  TOP: {label: 'TOP', code: 3},
  /** 下面 */
  BOTTOM: {label: 'BOTTOM', code: 4},
  /** 前面 */
  FRONT: {label: 'FRONT', code: 5},
  /** 背面 */
  BACK: {label: 'BACK', code: 6},
  /** 芯材 */
  CENTER: {label: 'CENTER', code: 7}
}

/** 選択パーツタイプ */
export const PT_SET_SELECT = {
  NORMAL: 1, // 通常
  EXCLUSION: 2, // 排他
  SYNCHRO: 3 // 同期
}

/** 操作種別 */
export const EDIT_TYPE = {
  MOVE: 'MOVE', // 移動
  RESIZE: 'RESIZE', // リサイズ
  ADD: 'ADD', // 空間追加
  UNDEFINED: 'UNDEFINED'
}

/** 選択モード */
export const SELECT_MODE = {
  CABINET: {code: 'CABINET', label: 'スケルトン・固定棚・カウンター・パネル', short: '箱'},
  DOOR_DRAWER_INFILL: {code: 'DOOR_DRAWER_INFILL', label: '引出し ・可動棚・扉', short: '扉・インフィル'}
}

/** キャンバス種別 */
export const CANVAS_TYPE = {
  MAIN: 'main',
  UPSIDE: 'upside',
  SIDE: 'side',
  UNDEFINED: 'undefined'
}

/** ビュー種別 */
export const VIEW_TYPE = {
  FRONT: {code: 'FRONT', label: '正面', isBase: false},
  BACK: {code: 'BACK', label: '裏面', isBase: true},
  TOP: {code: 'TOP', label: '上面', isBase: false},
  BOTTOM: {code: 'BOTTOM', label: '下面', isBase: true},
  RIGHT: {code: 'RIGHT', label: '右面', isBase: false},
  LEFT: {code: 'LEFT', label: '左面', isBase: true},
  UNDEFINED: {code: 'UNDEFINED', label: '', isBase: null}
}
/**
 * ビュー組み合わせ
 * rotate:右回り正
 * inverse:左下原点時に{false, false}
 */
export const VIEW_SET = [
  {
    no: 1,
    main: {viewType: VIEW_TYPE.FRONT, rotate: 0, inverse: {x: false, y: false}},
    upside: {viewType: VIEW_TYPE.TOP, rotate: 0, inverse: {x: false, y: true}},
    side: {viewType: VIEW_TYPE.RIGHT, rotate: 0, inverse: {x: true, y: false}}
  },
  {
    no: 2,
    main: {viewType: VIEW_TYPE.RIGHT, rotate: 0, inverse: {x: true, y: false}},
    upside: {viewType: VIEW_TYPE.TOP, rotate: -90, inverse: {x: true, y: true}},
    side: {viewType: VIEW_TYPE.BACK, rotate: 0, inverse: {x: true, y: false}}
  },
  {
    no: 3,
    main: {viewType: VIEW_TYPE.BACK, rotate: 0, inverse: {x: true, y: false}},
    upside: {viewType: VIEW_TYPE.TOP, rotate: 180, inverse: {x: true, y: false}},
    side: {viewType: VIEW_TYPE.LEFT, rotate: 0, inverse: {x: false, y: false}}
  },
  {
    no: 4,
    main: {viewType: VIEW_TYPE.LEFT, rotate: 0, inverse: {x: false, y: false}},
    upside: {viewType: VIEW_TYPE.TOP, rotate: 90, inverse: {x: false, y: false}},
    side: {viewType: VIEW_TYPE.FRONT, rotate: 0, inverse: {x: false, y: false}}
  },
  {
    no: 5,
    main: {viewType: VIEW_TYPE.TOP, rotate: 0, inverse: {x: false, y: true}},
    upside: {viewType: VIEW_TYPE.FRONT, rotate: 0, inverse: {x: false, y: false}},
    side: {viewType: VIEW_TYPE.RIGHT, rotate: 90, inverse: {x: true, y: true}}
  },
  {
    no: 6,
    main: {viewType: VIEW_TYPE.BOTTOM, rotate: 0, inverse: {x: false, y: false}},
    upside: {viewType: VIEW_TYPE.FRONT, rotate: 0, inverse: {x: false, y: false}},
    side: {viewType: VIEW_TYPE.RIGHT, rotate: -90, inverse: {x: false, y: false}}
  }
]

/** 面種別 */
export const FACE_TYPE = {
  FRONT: 'FRONT', // 前面
  BACK: 'BACK', // 裏面
  TOP: 'TOP', // 上面
  BOTTOM: 'BOTTOM', // 下面
  RIGHT: 'RIGHT', // 右面
  LEFT: 'LEFT', // 左面
  LRC: 'LRC', // X軸センター
  BTC: 'BTC', // Y軸センター
  BFC: 'BFC', // Z軸センター
  UNDEFINED: 'UNDEFINED'
}

/** 頂点種別 */
export const CORNER_TYPE = {
  LB: {code: 1, label: 'LB'},
  RB: {code: 2, label: 'RB'},
  RT: {code: 3, label: 'RT'},
  LT: {code: 4, label: 'LT'},
  BC: {code: 5, label: 'BC'},
  RC: {code: 6, label: 'RC'},
  TC: {code: 7, label: 'TC'},
  LC: {code: 8, label: 'LC'},
  CC: {code: 9, label: 'CC'}
}

/** 軸種別 */
export const AXIS_TYPE = {
  X: 'X', // x軸
  Y: 'Y', // y軸
  Z: 'Z', // z軸
  UNDEFINED: 'UNDEFINED'
}

/** モジュール種別 */
export const MODULE_TYPE = {
  PITCH: {code: 1, label: 'ピッチ'},
  FIX: {code: 2, label: '固定値'}
}

/** 扉の被せ種別 */
export const DOOR_WRAP_TYPE = {
  DEFAULT: {code: 0, label: '固定値'},
  NONE: {code: 1, label: 'なし'},
  HALF: {code: 2, label: '半被せ'},
  ALL: {code: 3, label: '全被せ'}
}

/** マトリクス設定種別 */
export const MATRIX_TYPE = {
  NUMERIC: {code: 1, label: '数値'},
  STRING: {code: 2, label: '文字列'}
}

/** 受注ステータス */
export const PAYMENT_STATUS = {
  // PAYMENT_RUN: {code: 1, label: '受注登録'},
  // PAYMENT_COMP: {code: 2, label: '決済完了'},
  // PAYMENT_CANCEL: {code: 3, label: 'ｷｬﾝｾﾙ'},
  // NO_PAYMENT: {code: 4, label: '未入金'},
  // PAYMENT_CONFIRM: {code: 5, label: '決済確認'},
  // PAYMENT_ORDER: {code: 6, label: '発注'},
  // MANUFACTURE_ARRANGE: {code: 7, label: '製造手配'},
  // ACCEPTING_ORDER: {code: 8, label: '受注'},
  // DURING_MANUFACTURING: {code: 9, label: '製造中'},
  // COMPLETE_MANUFACTURING: {code: 10, label: '製造完了'},
  // SHIPPING: {code: 11, label: '商品発送'},
  // CONSTRUCTION: {code: 12, label: '施工'},
  // INSPECTION: {code: 13, label: '検収'},
  // DELIVERY_COMPLETE: {code: 14, label: '納品完了'},
  // RESEARCH_ORDER: {code: 21, label: '事前調査依頼'},
  // RESEARCH_CANCEL: {code: 22, label: '事前調査依頼キャンセル'},
  // RESEARCH_COMPLETE: {code: 23, label: '事前調査依頼完了'},
  // SAVE_CART: {code: 31, label: 'カート保存'},
  // AFTER_CART: {code: 32, label: '後で買う'},
  // DELETE_CART: {code: 33, label: 'カート削除'}
  PLAN_STATUS_EC_CANCEL: {code: 103, label: 'ECキャンセル'},
  PLAN_STATUS_EC_NO_PAYMENT: {code: 104, label: 'EC未入金'},
  PLAN_STATUS_EC_PAYMENT: {code: 106, label: 'EC発注'},
  PLAN_STATUS_RESEARCH: {code: 121, label: '事前調査依頼'},
  PLAN_STATUS_RESEARCH_CANCEL: {code: 122, label: '事前調査依頼キャンセル'},
  PLAN_STATUS_RESEARCH_DEPLOY: {code: 123, label: '事前調査結果反映'},
  PLAN_STATUS_RESEARCH_COMPLETE: {code: 124, label: '事前調査完了'},
  PLAN_STATUS_CART_SAVE: {code: 131, label: 'カート保存'},
  PLAN_STATUS_CART_AFTER: {code: 132, label: '後で買う'},
  PLAN_STATUS_CART_DELETE: {code: 133, label: 'カート削除'}
}

/** 出力タイプ */
export const OUTPUT_TYPE = {
  OUTPUT_SH_PROCESS: {code: 1, label: '加工図'},
  OUTPUT_SH_UNIT: {code: 2, label: 'ユニット図'},
  OUTPUT_SH_COMB: {code: 3, label: 'コンバイン図'},
  OUTPUT_SH_PLAN: {code: 5, label: '意匠図'},
  OUTPUT_SH_UNIT_CLOSEUP: {code: 9, label: 'ユニット拡大図'},
  OUTPUT_SH_PLAN_GENCHOU: {code: 10, label: '現調記入用紙'},
  OUTPUT_NESTING_PANEL: {code: 13, label: '木取り図(パネルソー)'},
  OUTPUT_NESTING_RUNNNING: {code: 14, label: '木取り図(ランニングソー)'},
  OUTPUT_PRESENTATION: {code: 15, label: 'プレゼンシート'},
  OUTPUT_ESTIMATE: {code: 16, label: '見積書'},
  OUTPUT_MASTER_BOM: {code: 17, label: 'MasterBom'},
  OUTPUT_CG: {code: 18, label: 'CG'},
  OUTPUT_E_BOM: {code: 19, label: 'E-BOM'},
  OUTPUT_NESTING_CUTDATA: {code: 20, label: '木取りカットデータ'},
  OUTPUT_PRODUCTION_PLAN: {code: 21, label: '生産計画リスト'},
  OUTPUT_MANUFACTURE_DOC: {code: 22, label: '製造指示'},
  OUTPUT_MATERIAL_LIST: {code: 23, label: '資材所要量一覧'},
  OUTPUT_PARTS_LABEL: {code: 24, label: 'パーツラベル'},
  OUTPUT_NC_DATA: {code: 25, label: 'NC DATA'},
  OUTPUT_RISE: {code: 30, label: 'RISE CSV'}
}

/** 出力図面形式 */
export const SHEET_FILE_TYPE = {
  FILE_PDF: {code: 1, label: 'PDF'},
  FILE_DXF: {code: 2, label: 'DXF'}
}

/** プランステータス */
export const PLAN_STATUS = {
  SALES_A: {code: 1, label: 'A'},
  SALES_B: {code: 2, label: 'B'},
  SALES_C: {code: 3, label: 'C'},
  ORDER_REQUEST: {code: 5, label: '発注依頼'},
  ORDER: {code: 7, label: '受注'},
  ORDER_CONFIRMED: {code: 9, label: '受注確定'},
  MANUFACTURE: {code: 20, label: '生産計画済'},
  SHIP_COMPLETE: {code: 50, label: '生産完了'},
  DELIVERY_COMPLETE: {code: 55, label: '納品完了'},
  CANCEL: {code: 60, label: '失注'},
  EC_CANCEL: {code: 61, label: 'キャンセル'},
  EXCLUDED: {code: 70, label: '対象外'},
  SKETCH_ORDER: {code: 150, label: 'スケッチオーダー'},
  UNDEFINED: {code: 0, label: '未設定'}
}

/** プランリスト種別 */
export const LIST_TYPE = {
  SALES: {code: 1, label: '営業管理'},
  ORDER: {code: 2, label: '受注管理'},
  OUTPUT: {code: 3, label: '生産指示'},
  MANUFACTURE: {code: 4, label: '生産管理'},
  SKETCH: {code: 5, label: 'スケッチオーダー'}
}

/** コンテンツタイプ */
export const CONTENTS_TYPE = {
  UM_CODE: 1,
  STYLE: 2
}



// WEBPACK FOOTER //
// ./src/main/js/constants/Type.js